import {
  FETCH_RECENT_DESTINATIONS,
  FETCH_RECENT_DESTINATIONS_SUCCESS,
} from "../store/types";

const INITIAL_STATE = {
  destinations: [],
  loading: false,
};

export const recentdestinationsreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RECENT_DESTINATIONS:
      return { ...state, loading: true };
    case FETCH_RECENT_DESTINATIONS_SUCCESS:
      return { ...state, destinations: action.payload, loading: false };
    default:
      return state;
  }
};
